import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import { LandingLayout } from '../landing/shared/LandingLayout';
import { SEOHead } from '../landing/shared/SEOHead';

export default function TermsOfServicePage() {
  const { t } = useTranslation('legal');

  const sections = [
    'intro',
    'description',
    'accounts',
    'acceptable',
    'payment',
    'googleApi',
    'termination',
    'liability',
    'indemnification',
    'changes',
    'governing',
    'contact',
  ] as const;

  return (
    <LandingLayout>
      <SEOHead
        title={t('terms.title', 'Terms of Service')}
        description={t('terms.seoDescription')}
        canonical="https://slotyapp.com/terms"
      />
      <div className="bg-gray-50 py-12">
        {/* Page Header */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
          <div className="flex items-center gap-3">
            <FileText className="h-8 w-8 text-blue-600" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                {t('terms.title', 'Terms of Service')}
              </h1>
              <p className="text-sm text-gray-500">
                {t('terms.lastUpdated', 'Last updated')}: December 2024
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm border p-6 sm:p-8 space-y-8">
            {sections.map((section) => (
              <section key={section} className="space-y-4">
                <h2 className="text-xl font-semibold text-gray-900">
                  {t(`terms.sections.${section}.title`)}
                </h2>

                {section === 'accounts' || section === 'acceptable' ? (
                  <div className="space-y-4">
                    {section === 'acceptable' && (
                      <p className="text-gray-600">
                        {t(`terms.sections.${section}.intro`)}
                      </p>
                    )}
                    <ul className="space-y-2 text-gray-600 list-disc list-inside">
                      {(t(`terms.sections.${section}.items`, { returnObjects: true }) as string[]).map(
                        (item: string, idx: number) => (
                          <li key={idx}>{item}</li>
                        )
                      )}
                    </ul>
                  </div>
                ) : section === 'contact' ? (
                  <div className="space-y-2">
                    <p className="text-gray-600">
                      {t(`terms.sections.${section}.content`)}
                    </p>
                    <p className="text-blue-600">
                      <a href={`mailto:${t(`terms.sections.${section}.email`)}`}>
                        {t(`terms.sections.${section}.email`)}
                      </a>
                    </p>
                  </div>
                ) : (
                  <p className="text-gray-600">
                    {t(`terms.sections.${section}.content`)}
                  </p>
                )}
              </section>
            ))}
          </div>
        </div>
      </div>
    </LandingLayout>
  );
}
